import { Badge } from '../../shared/ui/Badge.js';
import { Button } from '../../shared/ui/Button.js';

interface SuspensionSwitchProps {
  enabled: boolean;
  busy: boolean;
  onSuspend: () => void;
  onResume: () => void;
}

/**
 * Cuts or restores the whole layer (functional §5.7): capture, guidance and
 * feedback stop together at the SDK's next configuration fetch, within a minute
 * on open pages. The site itself is never touched.
 */
export function SuspensionSwitch({ enabled, busy, onSuspend, onResume }: SuspensionSwitchProps) {
  const confirmAndSuspend = () => {
    if (
      window.confirm(
        'Couper l’aide ? Sur toutes les pages du portail, plus aucune aide ne s’affiche et plus rien n’est mesuré, dans la minute. Le site continue de fonctionner normalement.',
      )
    ) {
      onSuspend();
    }
  };

  return (
    <div className="script__switch" data-testid="suspension-switch" data-enabled={enabled}>
      <div>
        <p className="script__switch-state">
          {enabled ? (
            <Badge tone="positive">Aide en ligne</Badge>
          ) : (
            <Badge tone="negative">Aide coupée</Badge>
          )}
        </p>
        <p className="script__hint">
          {enabled
            ? 'Le portail affiche les aides publiées et mesure le parcours des usagers, sans aucune donnée personnelle.'
            : 'Plus aucune aide ne s’affiche et plus rien n’est mesuré sur le portail. Le site fonctionne normalement.'}
        </p>
      </div>
      {enabled ? (
        <Button variant="danger" disabled={busy} onClick={confirmAndSuspend}>
          Couper l'aide
        </Button>
      ) : (
        <Button variant="primary" disabled={busy} onClick={onResume}>
          Rallumer l'aide
        </Button>
      )}
    </div>
  );
}
